import React from 'react'
import {connect} from 'react-redux'

import CompanyForm from '../components/CompanyForm'
import {updateAccount} from '../actions/account'
import AccountForm from '../components/AccountForm'
import PasswordForm from '../components/PasswordForm'

const Account = ({account={}, submit}) => {
  const company = account.company || {}

  return (<React.Fragment>
    <div className="row">
      <div className="col-sm-12">
        <div className="page-title-box">
          <h4 className="page-title">Konto</h4>
          <div className="clearfix"/>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-sm-6 col-xs-12">
        <AccountForm account={account} submit={submit}/>
        <PasswordForm/>
      </div>

      <div className="col-sm-6 col-xs-12">
        <CompanyForm company={company} submit={submit}/>
      </div>
    </div>

  </React.Fragment>)
}

export default connect(state => ({
  account: state.account.accessibleAccounts.find(a => a.id === state.account.currentAccountId)
}), dispatch => ({
  submit: (values) => dispatch(updateAccount(values))
}))(Account)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/Account.js